import React, {useEffect, useState} from 'react'
import {Button, Card, Checkbox, Col, Form, Input, InputNumber, message, Modal, Row, Select} from "antd";
import TextArea from "antd/lib/input/TextArea";
import {DEFAULT_GUTTER} from "../../constants";
import {DeleteOutlined} from "@ant-design/icons";
import api from "../../api";
import {useAuth} from "../../auth";
import {pickUpSlotToHuman, isValidIban} from "../../helpers";

export default function StoreConfiguration() {
    const {company} = useAuth();
    const [pickupModalFormOpen, setPickupModalFormOpen] = useState(false);
    const [pickUpSlots, setPickUpSlots] = useState([]);
    const [form] = Form.useForm();
    const [pickUpSlotForm] = Form.useForm();

    useEffect(() => {
        if (company && company.id) {
            api.getPickUpSlots(company.id).then(setPickUpSlots)
        }
    }, [company]);

    // Initialize form with company data
    form.setFieldsValue({
        is_on_appointment_enabled: company.is_on_appointment_enabled,
        is_phone_enabled: company.is_phone_enabled,
        contact_phone: company.contact_phone,
        // road side stall
        is_stall_enabled: company.is_stall_enabled,
        stall_instructions: company.stall_instructions,
        // pickup
        is_pickup_enabled: company.is_pickup_enabled,
        pickup_instructions: company.pickup_instructions,
        // delivery
        is_delivery_enabled: company.is_delivery_enabled,
        delivery_instructions: company.delivery_instructions,
        delivery_free_range: company.delivery_free_range,
        delivery_max_range: company.delivery_max_range,
        delivery_base_price: company.delivery_base_price,
        delivery_km_price: company.delivery_km_price,

        iban: company.iban || '',
    });

    const hours = Array.from({length: 18}, (_, i) => i + 6); // 6 to 20

    return (
        <div>
            <Row>
                <Col md={18} xs={24}>
                    <h1 className={"mar-b-1"}>Hoe kunnen mensen het bij je afhalen of bezorg je?</h1></Col>
                <Col md={6} xs={24} className={"text-right mar-b-1"}>
                    <Button type={"primary"} size={"large"} onClick={() => {
                        form.validateFields().then(() => {

                            api.updateCompanyStore(company.id, form.getFieldsValue()).then(() => {
                                message.success("Instellingen opgeslagen")
                            })
                        })
                    }}>Instellingen opslaan</Button>
                </Col>
            </Row>
            <Form layout={"vertical"} form={form}>
                <Row gutter={DEFAULT_GUTTER}>
                    <Col md={12} xs={24}>
                        <Card style={{height: '100%', background: 'white'}}>
                            <h1>Op afspraak</h1>
                            <Form.Item name={"is_on_appointment_enabled"} valuePropName={"checked"}>
                                <Checkbox>
                                    Flexibel, dit spreek ik zelf met kopers af via Oogst.app of telefoon
                                </Checkbox>
                            </Form.Item>

                            <Form.Item name={"is_phone_enabled"} valuePropName={"checked"}>
                                <Checkbox>
                                    Geef mensen die gekocht hebben mijn telefoonnummer
                                </Checkbox>
                            </Form.Item>

                            <Form.Item label={"Telefoonnummer"} name={"contact_phone"}>
                                <Input/>
                            </Form.Item>
                        </Card>
                    </Col>
                    <Col md={12} xs={24}>
                        <Card style={{height: '100%', background: 'white'}}>

                            <h1>Kraampje</h1>

                            <Form.Item name={"is_stall_enabled"} valuePropName={"checked"}>
                                <Checkbox>
                                    Ik heb een kraampje aan de weg, mensen mogen het zelf pakken
                                </Checkbox>
                            </Form.Item>

                            <Form.Item label={"Kraam instructie"} name={"stall_instructions"}>
                                <TextArea
                                    placeholder={"Bijv: Neem zelf een tas mee, het staat klaar in de kraam."}></TextArea>
                            </Form.Item>

                            <Button>Download QR Code voor bij de kraam</Button>

                        </Card>
                    </Col>
                    <Col md={12} xs={24}>
                        <Card style={{height: '100%', background: 'white'}}>
                            <h2>Afhaalmomenten</h2>
                            <Form.Item name={"is_pickup_enabled"} valuePropName={"checked"}>
                                <Checkbox>
                                    Afhaalmomenten inschakelen
                                </Checkbox>
                            </Form.Item>
                            <Form.Item label={"Afhaalinstructie"} name={"pickup_instructions"}>
                                <TextArea
                                    placeholder={"Bijv: Het staat klaar in een tasje in het gangetje naast het huis."}></TextArea>
                            </Form.Item>
                            <Button className={"mar-b-1"} onClick={() => {
                                setPickupModalFormOpen(true);
                            }}>Afhaalmoment toevoegen</Button>

                            <h3>Afhaalmomenten</h3>

                            {pickUpSlots.map((slot => (
                                <Row key={`slot`+slot.id} gutter={DEFAULT_GUTTER}>
                                    <Col span={16}>
                                        <p>{pickUpSlotToHuman(slot)}</p>
                                    </Col>
                                    <Col span={8} className={"text-right"}>
                                        <Button type={"link"} danger onClick={() => {
                                            api.deletePickUpSlot(company.id, slot.id).then(() => {
                                                message.success("Afhaalmoment verwijderd");
                                                setPickUpSlots(pickUpSlots.filter(s => s.id !== slot.id));
                                            })
                                        }}>
                                            <DeleteOutlined/>
                                        </Button>
                                    </Col>
                                </Row>
                            )))}
                        </Card>
                    </Col>
                    <Col md={12} xs={24}>
                        <Card style={{height: '100%', background: 'white'}}>
                            <h2>Bezorging</h2>
                            <Form.Item name={"is_delivery_enabled"} valuePropName={"checked"}>
                                <Checkbox>
                                    Ik bezorg de groenten
                                </Checkbox>
                            </Form.Item>
                            <Form.Item label={"Bezorginstructie"} name={"delivery_instructions"}>
                                <TextArea
                                    placeholder={"Bijv: We bezorgen op woensdag in de buurt en op vrijdag in het buitengebied. Als je niet thuis bent zetten we het op een beschutte plek neer."}></TextArea>
                            </Form.Item>
                            <Form.Item name={"delivery_max_range"} label={"Maximale afstand in km"}>
                                <InputNumber min={0} step={0.01} style={{width: "100%"}}/>
                            </Form.Item>
                            <Form.Item name={"delivery_free_range"} label={"Bezorging gratis binnen x km"}>
                                <InputNumber min={0} step={0.01} style={{width: "100%"}}/>
                            </Form.Item>
                            <Form.Item name={"delivery_base_price"} label={"Basistarief bezorging"}>
                                <InputNumber min={0} step={0.01} style={{width: "100%"}}/>
                            </Form.Item>
                            <Form.Item name={"delivery_km_price"} label={"Meerprijs per km"}>
                                <InputNumber min={0} step={0.01} style={{width: "100%"}}/>
                            </Form.Item>
                        </Card>
                    </Col>
                    <Col md={12} xs={24}>
                        <Card style={{height: '100%', background: 'white'}}>
                            <h2>Uitbetaling</h2>
                            <Form.Item
                                label="IBAN"
                                name="iban"
                                rules={[
                                    {
                                        validator: (_, value) => {
                                            if (!value || isValidIban(value)) {
                                                return Promise.resolve();
                                            }
                                            return Promise.reject(new Error('Vul een geldig IBAN nummer in'));
                                        },
                                    },
                                ]}
                            >
                                <Input placeholder="Enter IBAN"/>
                            </Form.Item>
                            <p>We betalen iedere woensdag de tegoeden uit op dit rekeningnummer.</p>
                        </Card>
                    </Col>
                </Row>
            </Form>

            <Modal open={pickupModalFormOpen} onCancel={() => {
                setPickupModalFormOpen(false);
                pickUpSlotForm.resetFields();
            }} okText={"Toevoegen"} onOk={() => {
                api.createPickUpSlot(company.id, pickUpSlotForm.getFieldsValue()).then(() => {
                    message.success("Afhaalmoment toegevoegd");
                    setPickupModalFormOpen(false);
                    pickUpSlotForm.resetFields();
                })
            }}>
                <h1>Afhaalmoment toevoegen</h1>
                <Form layout={"vertical"} form={pickUpSlotForm}>
                    <Form.Item label={"Dag"} name={"day_of_week"}>
                        <Select>
                            <Select.Option value={0}>Maandag</Select.Option>
                            <Select.Option value={1}>Dinsdag</Select.Option>
                            <Select.Option value={2}>Woensdag</Select.Option>
                            <Select.Option value={3}>Donderdag</Select.Option>
                            <Select.Option value={4}>Vrijdag</Select.Option>
                            <Select.Option value={5}>Zaterdag</Select.Option>
                            <Select.Option value={6}>Zondag</Select.Option>
                        </Select>
                    </Form.Item>
                    <Row gutter={DEFAULT_GUTTER}>
                        <Col span={12}>
                            <Form.Item label={"Van"} name={"starts_at"}>

                                <Select>

                                    {hours.map((hour) => (
                                        <Select.Option key={hour} value={hour}>
                                            {`${String(hour).padStart(2, '0')}:00`}
                                        </Select.Option>
                                    ))}

                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label={"Tot"} name={"ends_at"}>
                                <Select>
                                    {hours.map((hour) => (
                                        <Select.Option key={hour} value={hour}>
                                            {`${String(hour).padStart(2, '0')}:00`}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Modal>

        </div>
    )
}